module.exports = __webpack_public_path__ + "0bd7453d85f6237c46ef5ab71c1101c4.svg";